import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
function i(n, c) {
  return l(), e("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 473.681 473.681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("path", {
      style: { fill: "#008E56" },
      d: `M315.8,13.537l-27.64,76.628c25.511,84.197,25.511,209.158,0,293.358l27.639,76.624\r
	c91.975-32.523,157.881-120.201,157.881-223.309C473.682,133.731,407.774,46.057,315.8,13.537z`
    }),
    t("g", null, [
      t("path", {
        style: { fill: "#E7E7E7" },
        d: `M315.8,90.161V13.537c-24.7-8.736-51.266-13.534-78.961-13.534\r
		C273.359,0.004,222.723,123.772,315.8,90.161z`
      }),
      t("path", {
        style: { fill: "#E7E7E7" },
        d: `M236.839,473.681c27.695,0,54.261-4.798,78.961-13.534v-76.624\r
		C223.657,374.328,236.839,473.681,236.839,473.681z`
      })
    ]),
    t("path", {
      style: { fill: "#E97E24" },
      d: `M0.001,236.838c0,103.456,66.355,191.362,158.805,223.623V13.223\r
	C66.356,45.484,0.001,133.391,0.001,236.838z`
    }),
    t("path", {
      style: { fill: "#14B36F" },
      d: "M315.8,90.161v293.358C341.315,299.323,341.315,174.361,315.8,90.161z"
    }),
    t("path", {
      style: { fill: "#F3F1F2" },
      d: `M315.8,383.523V90.161C299.672,36.94,273.356,0,236.839,0c-27.351,0-53.592,4.693-78.034,13.223\r
	v447.238c24.442,8.523,50.682,13.219,78.034,13.219C273.359,473.681,299.674,436.745,315.8,383.523z`
    })
  ]);
}
export {
  i as default
};
